module.exports = __webpack_public_path__ + "img/LONG-SLEEVE-TEE_FRONT_RED-BACK.720df4fc.jpg";